// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9eaTM","hello":"Home_hello__bE-gR","name":"Home_name__PFf63"};